// Initial file list view
const FETCH_BULK_REFUND_REQUEST = 'FETCH_BULK_REFUND_REQUEST';
const FETCH_BULK_REFUND_SUCCESS = 'FETCH_BULK_REFUND_SUCCESS';
const FETCH_BULK_REFUND_ERROR = 'FETCH_BULK_REFUND_ERROR';

// Uploading the file
const UPLOAD_BULK_REFUND_FILE_REQUEST = 'UPLOAD_BULK_REFUND_FILE_REQUEST';
const UPLOAD_BULK_REFUND_FILE_SUCCESS = 'UPLOAD_BULK_REFUND_FILE_SUCCESS';
const UPLOAD_BULK_REFUND_FILE_ERROR = 'UPLOAD_BULK_REFUND_FILE_ERROR';

// Downloading a file from by its requestId
const DOWNLOAD_BULK_REFUND_FILE_BY_ID_REQUEST =
    'DOWNLOAD_BULK_REFUND_FILE_BY_ID_REQUEST';
const DOWNLOAD_BULK_REFUND_FILE_BY_ID_SUCCESS =
    'DOWNLOAD_BULK_REFUND_BY_ID_SUCCESS';
const DOWNLOAD_BULK_REFUND_FILE_BY_ID_ERROR =
    'DOWNLOAD_BULK_REFUND_BY_ID_ERROR';

// Download bulk refund pre filled file
const DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_REQUEST =
    'DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_REQUEST';
const DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_SUCCESS =
    'DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_SUCCESS';
const DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_ERROR =
    'DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_ERROR';

// Fetch a file view
const FETCH_BULK_REFUND_BY_ID_REQUEST = 'FETCH_BULK_REFUND_BY_ID_REQUEST';
const FETCH_BULK_REFUND_BY_ID_SUCCESS = 'FETCH_BULK_REFUND_BY_ID_SUCCESS';
const FETCH_BULK_REFUND_BY_ID_ERROR = 'FETCH_BULK_REFUND_BY_ID_ERROR';

// Show and hide loaders
const HIDE_BULK_REFUND_LOADER = 'HIDE_BULK_REFUND_LOADER';
const SHOW_BULK_REFUND_LOADER = 'SHOW_BULK_REFUND_LOADER';

export {
    FETCH_BULK_REFUND_REQUEST,
    FETCH_BULK_REFUND_SUCCESS,
    FETCH_BULK_REFUND_ERROR,
    HIDE_BULK_REFUND_LOADER,
    SHOW_BULK_REFUND_LOADER,
    UPLOAD_BULK_REFUND_FILE_REQUEST,
    UPLOAD_BULK_REFUND_FILE_SUCCESS,
    UPLOAD_BULK_REFUND_FILE_ERROR,
    DOWNLOAD_BULK_REFUND_FILE_BY_ID_REQUEST,
    DOWNLOAD_BULK_REFUND_FILE_BY_ID_SUCCESS,
    DOWNLOAD_BULK_REFUND_FILE_BY_ID_ERROR,
    DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_REQUEST,
    DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_SUCCESS,
    DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_ERROR,
    FETCH_BULK_REFUND_BY_ID_REQUEST,
    FETCH_BULK_REFUND_BY_ID_SUCCESS,
    FETCH_BULK_REFUND_BY_ID_ERROR,
};
